import { i as o } from "./index778.mjs";
var r = o, t = function(i) {
  return r(i) || i === null;
};
export {
  t as i
};
